module.exports = __webpack_public_path__ + "1f5d2d6f768495449ed00f6b1be9b063.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/header/components/images/spop-umac-logo.png
 ** module id = 1467
 ** module chunks = 0
 **/